<template>
    <CCard>
        <CCardBody>
            <CContainer class="section" fluid>
                <CRow class="border-bottom">
                    <CCol md="10">
                        <h2 class="section__title my-4">{{ $t("options") }}</h2>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="end py-2">
                    <CButton color="transparent" @click="beautifyOptions('$v.forms.viewField.options.$model')">
                        {{ $t("beautify") }}
                    </CButton>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CForm
                            ref="formViewField"
                            @submit="submitForm($event, 'viewField')"
                        >
                            <CTextarea
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewField',
                                        fieldName: 'options',
                                    })
                                "
                                :value.sync="forms.viewField.options"
                                size="sm"
                                rows="20"
                                :placeholder="$t('enter_the_options')"
                            />
                        </CForm>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCardFooter class="d-flex">
            <ButtonSave
                color="success"
                @click="executeSubmitForm('formViewField')"
                :disabled="forms.viewField._loading"
            />
            <ButtonBack class="mr-3" title="Go back" />
        </CCardFooter>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import ButtonSave from "~/components/ButtonSave.vue";

/** Mixins */
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";

/** Others */
import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from "@coreui/icons";

export default {
    name: "FieldOptionsTab",
    mixins: [formMixin, validationMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
    },

    components: {
        ButtonBack,
        ButtonLoading,
        ButtonSave,
    },

    props: {
        field: {
            type: Object
        },
        mode: {
            type: String,
            default: "edit",
        },
        loading: Boolean,
    },

    data() {
        return {
            forms: {
                viewField: {
                    options: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
            jsonBeautify: null
        };
    },
    watch: {
        "forms.viewField._loading": {
            handler: async function (newValue) {
                this.$emit("update:loading", newValue);
            },
            deep: true,
        },
        
    },
    validations: {
        forms: {
            viewField: {
                options: {},
            },
        },
    },
    methods: {
        async updateField() {
            await this.sendForm({
                formName: "viewField",
                method: "PUT",
                url: "/fields/" + this.field.uuid,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        },
        async submitForm(e, formName) {
            e.preventDefault();
            await this.updateField();
        },
        beautifyOptions() {
            let beautifyValue = this.forms.viewField.options;
            console.log(beautifyValue);
            beautifyValue = beautifyValue
                .replace(/\n/g, "")
                .replace(/,/g, ",\n");
            this.forms.viewField.options = beautifyValue;
        },
        beautifyJson(){
            let beautifyValue = this.jsonBeautify;
            beautifyValue = JSON.stringify(JSON.parse(beautifyValue),undefined, 4);
            // console.log(beautifyValue);
            this.jsonBeautify = beautifyValue;
            // return JSON.parse(json, undefined, 4);
        },
    },
    async mounted() {
        this.forms.viewField.options = this.field.options;
    },
};
</script>

<style>
</style>